import { render } from "./Spinner.vue?vue&type=template&id=368b9aef&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=368b9aef&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368b9aef"]])

export default __exports__